import { createBreakpoints } from "@mui/system";
var MuiBreakpoints = createBreakpoints({}); // todo: wait for v5 to fix

export var BREAKPOINT_KEYS = MuiBreakpoints.keys;